import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Paragraph from '../../UI/Texts/Paragraph';
import { formatMoney } from '../../Common/decimalHelper';

const VisualizadorPrecioSinImpuestos = ({ 
  precioSinImpuestos, 
}) => {  
  const renderPrecioFormateado = (precio) => {
    if (precio === null || precio === undefined) return '';
    return formatMoney(precio);
  };

  return (
    <div className='visualizadorPrecioSinImpuestos' style={{ marginBottom: '20px' }}>
      <Paragraph 
        sx={{
          fontSize: '10px',
          fontFamily: 'Poppins',
          fontWeight: 300,
          color: '#b0b0b0',
        }}
      >
        Precio s/imp. Nacionales {renderPrecioFormateado(precioSinImpuestos)}
      </Paragraph>
    </div>
  );
};

VisualizadorPrecioSinImpuestos.defaultProps = {
  precioSinImpuestos: 0,
};

VisualizadorPrecioSinImpuestos.propTypes = {
  precioSinImpuestos: PropTypes.number,
};

export default VisualizadorPrecioSinImpuestos;